<template>
  <div class="content">
    <form>
      <writeoff-form :datas="dataall"></writeoff-form>
      <sklad :datas="dataall"></sklad>
      <reason :datas="dataall"></reason>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.writeoff.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import WriteoffForm from "./Form.vue"
import { Sklad,Reason} from "@/pages";
export default {
  components: {WriteoffForm,Sklad,Reason},
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Списания" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  created:function(){
    let self=this;
    axios
        .get("api/v1/write-off/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
            self.$store.state.saved=null;
        });
  },
  data() {
    return {
      dataall: {
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at: new Date().valueOf().toString().slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        user_id: parseInt(localStorage.getItem("user_id")),
        count_all: 0,
        number:0,
        reason_id:null,
        comment: "",
        summa_all:0,
        write_off_table : [
          {
            "product_id": 0,
            "count": 0,
            "current_balance":0,
            "shtrix_kod":""
          }
        ]
      }
    };
  }
};
</script>
